export default __webpack_public_path__ + "static/media/Freighter_Grey.b335be10.svg";